import React, { useState, useRef, useEffect } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { usePageData } from '../../contexts/DataContext';
import LoadingSpinner, { LoadingSkeleton } from '../common/LoadingSpinner';

const TestimonialsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(1);
  const trackRef = useRef(null);
  const { data: homePage, isLoading, error } = usePageData('homePage');
  
  const scrollLeft = () => {
    if (!homePage?.testimonials) return;
    setCurrentIndex(prev => prev > 0 ? prev - 1 : 0)
  }

  const scrollRight = () => {
    if (!homePage?.testimonials) return;
    setCurrentIndex(prev => prev < homePage.testimonials.length - 1 ? prev + 1 : homePage.testimonials.length - 1)
  }

  useEffect(() => {
    if (trackRef.current && homePage?.testimonials) {
      const cardWidth = 280 + 80 // width + gap
      trackRef.current.style.transform = `translateX(-${(currentIndex - 1) * cardWidth}px)`
    }
  }, [currentIndex, homePage?.testimonials])

  if (isLoading) {
    return (
      <section className="testimonial-section">
        <LoadingSkeleton type="text" count={2} />
        <div className="testimonial-wrapper">
          <LoadingSkeleton type="card" count={3} />
        </div>
      </section>
    );
  }

  if (error || !homePage || !homePage.testimonials) {
    return (
      <section className="testimonial-section">
        <h2>What <span>Clients</span> Says!</h2>
        <p className="subtitle">See how Resume slip helped people to achieve their goals!</p>
        <div className="testimonial-wrapper">
          <div className="testimonial-track" ref={trackRef}>
            <div className="testimonial active">
              <div className="user-info">
                <img src="https://randomuser.me/api/portraits/men/32.jpg" alt="Aryan" />
                <div>
                  <h4>Aryan</h4>
                  <span>Teacher</span>
                </div>
              </div>
              <p>Egastas elit dui scelerisque ut eu purus aliquam vitae habitasse.</p>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="testimonial-section">
      <h2>{homePage.testimonials_title?.replace('Clients', '<span>Clients</span>')}</h2>
      <p className="subtitle">{homePage.testimonials_subtitle}</p>

      <button className="arrow-btn left-btn" onClick={scrollLeft}>
        <FaChevronLeft />
      </button>
      
      <div className="testimonial-wrapper">
        <div className="testimonial-track" ref={trackRef}>
          {homePage.testimonials.map((testimonial, index) => (
            <div className={`testimonial ${index === currentIndex ? 'active' : ''}`} key={index}>
              <div className="user-info">
                {testimonial.image_url && (
                  <img src={testimonial.image_url} alt={testimonial.name} />
                )}
                <div>
                  <h4>{testimonial.name}</h4>
                  <span>{testimonial.role}</span>
                </div>
              </div>
              <p>{testimonial.text}</p>
            </div>
          ))}
        </div>
      </div>
      
      <button className="arrow-btn right-btn" onClick={scrollRight}>
        <FaChevronRight />
      </button>
    </section>
  )
}

export default TestimonialsSection